import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { CategoriesStorage } from '../documents';
import { routeParams } from '../shared/route-helpers';

@Injectable()
export class GeneralDocumentsGuard implements CanActivate {

    constructor(
        private router: Router,
        private categoriesStorage: CategoriesStorage
    ) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url: string = state.url;

        return this.categoriesStorage.generalCategories
            .pipe(
                map(gc => {
                    const cat = gc.find(c => c.categoryId === route.params[routeParams.childCategoryId]);
                    if (cat && cat.children.length > 0) {
                        const sub = cat.children[0].categoryId;
                        this.router.navigateByUrl(`${url}/${sub}`);
                        return false;
                    }
                    return true;
                })
            );
    }
}